import * as React from 'react';
import { MiniviewPlugin, log, render, extend, EVENT_NODE_UPDATED, EVENT_GROUP_UPDATED, EVENT_NODE_REMOVED, EVENT_GROUP_REMOVED, EVENT_GRAPH_CLEARED, BrowserUIBase, DropManager, SurfaceDropManager } from '@jsplumbtoolkit/browser-ui';
import * as ReactDOM from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var PROP_TOOLKIT = "toolkit";
var PROP_SURFACE = "surface";
var PROP_VERTEX = "vertex";
var REQUIRED_PROPS = [PROP_TOOLKIT, PROP_SURFACE, PROP_VERTEX];
/**
 * Base class for port/group/node components. Internal.
 * @internal
 */
var BaseVertexComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseVertexComponent, _React$Component);
  var _super = _createSuper(BaseVertexComponent);
  function BaseVertexComponent(props) {
    var _this;
    _classCallCheck(this, BaseVertexComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "toolkit", void 0);
    _defineProperty(_assertThisInitialized(_this), "surface", void 0);
    _defineProperty(_assertThisInitialized(_this), "vertex", void 0);
    REQUIRED_PROPS.forEach(function (rp) {
      var v = props.ctx ? props.ctx[rp] : props[rp];
      if (v == null) {
        throw new Error("JSPLUMB: BaseVertexComponent missing required prop '" + rp + "'; either pass directly to the component or use the `ctx` object provided by the Toolkit");
      } else {
        _this[rp] = v;
      }
    });
    return _this;
  }

  // in some cases this seems like the right thing to do. And in others, it causes React to complain about unmounted components.
  // componentDidUpdate(prevProps, prevState, snapshot) {
  //     this.surface && this.vertex && this.surface.repaint(this.vertex);
  // }
  _createClass(BaseVertexComponent, [{
    key: "removeVertex",
    value: function removeVertex() {
      this.toolkit.remove(this.vertex);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.toolkit = null;
      this.surface = null;
      this.vertex = null;
    }
  }]);
  return BaseVertexComponent;
}(React.Component);

/**
 * Base component that your node components can extend, to get access to a few helper methods.  It is not imperative
 * that you extend this component.
 */
var BaseNodeComponent = /*#__PURE__*/function (_BaseVertexComponent) {
  _inherits(BaseNodeComponent, _BaseVertexComponent);
  var _super = _createSuper(BaseNodeComponent);
  function BaseNodeComponent(props) {
    var _this;
    _classCallCheck(this, BaseNodeComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "node", void 0);
    _this.node = _this.vertex;
    return _this;
  }

  /**
   * Removes the node that this component represents.
   */
  _createClass(BaseNodeComponent, [{
    key: "removeNode",
    value: function removeNode() {
      this.toolkit.removeNode(this.vertex);
    }

    /**
     * Updates the node that this component represents.
     * @param data
     */
  }, {
    key: "updateNode",
    value: function updateNode(data) {
      this.toolkit.updateNode(this.vertex, data);
    }
  }]);
  return BaseNodeComponent;
}(BaseVertexComponent);

/**
 * Base component that your group components can extend, to get access to a few helper methods.  It is not imperative
 * that you extend this component.
 */
var BaseGroupComponent = /*#__PURE__*/function (_BaseVertexComponent) {
  _inherits(BaseGroupComponent, _BaseVertexComponent);
  var _super = _createSuper(BaseGroupComponent);
  function BaseGroupComponent(props) {
    var _this;
    _classCallCheck(this, BaseGroupComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "group", void 0);
    _this.group = _this.vertex;
    return _this;
  }

  /**
   * Removes the group that this component represents.
   */
  _createClass(BaseGroupComponent, [{
    key: "removeGroup",
    value: function removeGroup(alsoRemoveChildNodes) {
      this.toolkit.removeGroup(this.group, alsoRemoveChildNodes);
    }

    /**
     * Updates the group that this component represents.
     * @param data
     */
  }, {
    key: "updateGroup",
    value: function updateGroup(data) {
      this.toolkit.updateGroup(this.vertex, data);
    }
  }]);
  return BaseGroupComponent;
}(BaseVertexComponent);

/**
 * Base class for components that render Ports. Your port components can extend this to get access to a few helper methods.
 * You are expected to supply a `parent`
 */
var BasePortComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(BasePortComponent, _React$Component);
  var _super = _createSuper(BasePortComponent);
  function BasePortComponent(props) {
    var _this;
    _classCallCheck(this, BasePortComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", null);
    _defineProperty(_assertThisInitialized(_this), "props", null);
    _defineProperty(_assertThisInitialized(_this), "toolkit", void 0);
    _defineProperty(_assertThisInitialized(_this), "surface", void 0);
    _defineProperty(_assertThisInitialized(_this), "vertex", void 0);
    _this.state = props.data;
    _this.toolkit = props.toolkit;
    _this.surface = props.surface;
    _this.vertex = props.vertex;
    return _this;
  }

  /**
   * Gets the port that this component represents.
   */
  _createClass(BasePortComponent, [{
    key: "getPort",
    value: function getPort() {
      return this.vertex.getPort(this.state.id);
    }

    /**
     * Returns the ID of the port. This is the ID of the port on its node, not the unique id of the port
     * across the entire graph.
     */
  }, {
    key: "getPortId",
    value: function getPortId() {
      return this.toolkit.getPortId(this.state);
    }

    /**
     * Removes the port that this component represents.
     */
  }, {
    key: "removePort",
    value: function removePort() {
      return this.toolkit.removePort(this.vertex, this.getPortId());
    }

    /**
     * Updates the port that this component represents.
     * @param data
     */
  }, {
    key: "updatePort",
    value: function updatePort(data) {
      this.toolkit.updatePort(this.getPort(), data);
    }
  }]);
  return BasePortComponent;
}(React.Component);

/**
 * jsPlumb Toolkit Miniview Component
 */
var JsPlumbToolkitMiniviewComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(JsPlumbToolkitMiniviewComponent, _React$Component);
  var _super = _createSuper(JsPlumbToolkitMiniviewComponent);
  function JsPlumbToolkitMiniviewComponent() {
    var _this;
    _classCallCheck(this, JsPlumbToolkitMiniviewComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "props", null);
    _defineProperty(_assertThisInitialized(_this), "toolkit", void 0);
    _defineProperty(_assertThisInitialized(_this), "surface", void 0);
    _defineProperty(_assertThisInitialized(_this), "_container", void 0);
    _defineProperty(_assertThisInitialized(_this), "elementFilter", void 0);
    _defineProperty(_assertThisInitialized(_this), "typeFunction", void 0);
    return _this;
  }
  _createClass(JsPlumbToolkitMiniviewComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(c) {
          return _this2._container = c;
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.surface) {
        throw new Error("No `surface` set on JsPlumbToolkitMiniviewComponent");
      }
      this.surface = this.props.surface;
      this.toolkit = this.surface.toolkitInstance;
      this.elementFilter = this.props.elementFilter;
      this.typeFunction = this.props.typeFunction;
      this.surface.addPlugin({
        type: MiniviewPlugin.type,
        options: {
          container: this._container,
          elementFilter: this.elementFilter,
          typeFunction: this.typeFunction
        }
      });
    }
  }]);
  return JsPlumbToolkitMiniviewComponent;
}(React.Component);

var DIV = "div";

/**
 * Props for the Surface component. You are expected to provide, at a minimum, an instance of `BrowserUIReact` to this component, and
 * in practise you will also almost certainly want to pass a `view` and `renderParams`.
 *
 * Asynchronous rendering
 * ----------------------
 *
 * From version 5.8.0 onwards this component will, by default, render vertices "asynchronously", which is to say that
 * it will hold off informing the Toolkit that the rendering of some vertex has been completed until an internal
 * ResizeObserver detects that the initial hydration of the element is complete. This mechanism is of particular use when
 * you're bulk loading data and you're using React 18, as React 18's rendering pipeline does not always hydrate a
 * component immediately, and the Toolkit cannot therefore effectively run a layout or compute the positions of connectors.
 *
 * ResizeObserver is supported on all recent versions of modern browsers, but not on IE11.  In the absence of ResizeObserver,
 * the component will fall back to the "synchronous" rendering mechanism.
 *
 * It is extremely unlikely you will want to switch off asynchronous rendering, but you can do so by setting the
 * prop `asynchronous` to false.
 *
 * @public
 */

/**
 * Provides a React component that fronts a surface widget.
 */
var JsPlumbToolkitSurfaceComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(JsPlumbToolkitSurfaceComponent, _React$Component);
  var _super = _createSuper(JsPlumbToolkitSurfaceComponent);
  function JsPlumbToolkitSurfaceComponent(props) {
    var _this;
    _classCallCheck(this, JsPlumbToolkitSurfaceComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "view", void 0);
    _defineProperty(_assertThisInitialized(_this), "toolkit", void 0);
    _defineProperty(_assertThisInitialized(_this), "renderParams", void 0);
    _defineProperty(_assertThisInitialized(_this), "surface", void 0);
    _defineProperty(_assertThisInitialized(_this), "_container", void 0);
    _defineProperty(_assertThisInitialized(_this), "_asynchronous", void 0);
    _defineProperty(_assertThisInitialized(_this), "_vertices", void 0);
    _defineProperty(_assertThisInitialized(_this), "_resizeObserver", void 0);
    _defineProperty(_assertThisInitialized(_this), "_temporaryContainer", void 0);
    _this._vertices = [];
    _this.renderParams = _this.props.renderParams || {};
    _this.toolkit = _this.props.toolkit;
    _this.view = _this.props.view || {};
    _this.state = {
      vertices: []
    };
    _this._asynchronous = _this.props.asynchronous !== false;
    if (_this.toolkit == null) {
      throw new Error("Cannot instantiate a Surface component without providing `toolkit` in the props");
    }
    if (_this._asynchronous) {
      _this._temporaryContainer = document.createElement("div");
      _this._temporaryContainer.style.position = "fixed";
      _this._temporaryContainer.style.left = "10000px";
      _this._temporaryContainer.style.top = "10000px";
      _this._temporaryContainer.style.width = "100px";
      _this._temporaryContainer.style.height = "100px";
      _this._temporaryContainer.style.opacity = "0";
      document.body.appendChild(_this._temporaryContainer);
      try {
        _this._resizeObserver = new ResizeObserver(function (entries) {
          requestAnimationFrame(function () {
            entries.forEach(function (entry) {
              var vertexRepresentation = _this._vertices.find(function (v) {
                return v.domElement === entry.target;
              });
              if (vertexRepresentation != null) {
                if (vertexRepresentation.hydrated !== true) {
                  _this.surface.vertexRendered(vertexRepresentation.node, entry.target, vertexRepresentation.def, vertexRepresentation.payload.eventInfo);
                  vertexRepresentation.hydrated = true;
                } else {
                  _this.surface.jsplumb.revalidate(vertexRepresentation.domElement);
                }
              }
            });
          });
        });
      } catch (e) {
        _this._asynchronous = false;
        log("WARN: could not instantiate ResizeObserver. This is not fatal, but for React 18+ the absence of the ResizeObserver will make it difficult to compute a layout correctly after a bulk load. Your version of React is ".concat(React.version, "."), e);
      }
    }
    return _this;
  }
  _createClass(JsPlumbToolkitSurfaceComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var templateRenderer = {
        asynchronous: this._asynchronous,
        reactive: true,
        update: function update(el, data, v, renderer) {},
        render: function render(id, data, toolkit, type, surface, def, modelObject, node, eventInfo) {
          if (def.component || def.jsx) {
            var d = document.createElement(DIV);
            var payload = {
              data: data,
              toolkit: _this2.toolkit,
              surface: _this2.surface,
              surfaceComponent: _this2,
              componentId: modelObject.getFullId(),
              vertex: modelObject,
              props: _this2.props.childProps,
              element: d,
              eventInfo: eventInfo
            };

            // update state with a new React element placeholder
            _this2._vertices.push({
              data: data,
              def: def,
              payload: payload,
              domElement: d,
              key: modelObject.id,
              node: modelObject,
              hydrated: false
            });
            _this2._updateVertexState();

            // if running asynchronously we use the resize observer to detect the hydration of the component.
            // note that it is necessary to have added the element we're drawing into to the DOM in order for the
            // resize observer to detect it, so we append it to our temporary container, which is an element
            // that is positioned fixed and out of the viewport of the average display, with opacity 0.
            // we use the temporary container to avoid the rendered elements flashing up onto the canvas before
            // they are hydrated.
            if (_this2._resizeObserver != null) {
              _this2._temporaryContainer.appendChild(d);
              _this2._resizeObserver.observe(d);
            } else {
              _this2.surface.vertexRendered(modelObject, d, def, eventInfo);
            }
          } else {
            log("WARN: `component` not set for node/group - falling back to default template renderer with template " + id + ". Consider mapping a React component or some jsx in your view.");
          }
        },
        cleanupVertex: function cleanupVertex(objId, el) {
          el.parentNode && el.parentNode.removeChild(el);
          if (_this2._resizeObserver != null) {
            _this2._resizeObserver.unobserve(el);
          }
        },
        cleanupPort: function cleanupPort(objId, el) {
          // noop. React takes care of this.
        }
      };
      this.surface = render(this.toolkit, this._container, templateRenderer, extend(this.renderParams, {
        view: this.view
      }));
      var updateVertex = function updateVertex(vertexId, eventPayload) {
        var mergeData = function mergeData() {
          var data = {};
          if (eventPayload.originalData || eventPayload.updates) {
            data = extend(eventPayload.originalData, eventPayload.updates);
          } else if (eventPayload.newData) {
            extend(data, eventPayload.newData);
          }
          return data;
        };
        var entry = _this2._vertices.find(function (v) {
          return v.key === vertexId;
        });
        if (entry != null) {
          entry.data = mergeData();
          _this2._updateVertexState();
        }
      };
      var removeVertex = function removeVertex(id) {
        _this2._vertices = _this2._vertices.filter(function (n) {
          return n.payload.componentId !== id;
        });
        _this2._updateVertexState();
      };
      this.toolkit.bind(EVENT_NODE_UPDATED, function (p) {
        updateVertex(p.vertex.getFullId(), p);
      });
      this.toolkit.bind(EVENT_GROUP_UPDATED, function (p) {
        updateVertex(p.vertex.getFullId(), p);
      });
      this.toolkit.bind(EVENT_NODE_REMOVED, function (p) {
        removeVertex(p.nodeId);
      });
      this.toolkit.bind(EVENT_GROUP_REMOVED, function (p) {
        removeVertex(p.group.id);
      });
      this.toolkit.bind(EVENT_GRAPH_CLEARED, function () {
        _this2._vertices.length = 0;
        _this2._updateVertexState();
      });
    }
  }, {
    key: "_updateVertexState",
    value: function _updateVertexState() {
      this.setState({
        vertices: this._vertices
      });
    }
  }, {
    key: "generateComponent",
    value: function generateComponent(ns) {
      var comp;
      if (ns.def.component) {
        comp = /*#__PURE__*/React.createElement(ns.def.component, ns.payload);
      } else if (ns.def.jsx) {
        comp = ns.def.jsx({
          vertex: ns.node,
          toolkit: this.toolkit,
          surface: this.surface,
          data: ns.node.data,
          props: this.props.childProps || {},
          element: ns.domElement
        });
      }
      return comp;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(c) {
          return _this3._container = c;
        }
      }, this.state.vertices.map(function (ns) {
        return /*#__PURE__*/ReactDOM.createPortal(_this3.generateComponent(ns), ns.domElement, ns.key);
      }));
    }
  }]);
  return JsPlumbToolkitSurfaceComponent;
}(React.Component);

/**
 * Extension of the Toolkit suitable for use with the React integration.
 */
var BrowserUIReact = /*#__PURE__*/function (_BrowserUIBase) {
  _inherits(BrowserUIReact, _BrowserUIBase);
  var _super = _createSuper(BrowserUIReact);
  function BrowserUIReact() {
    _classCallCheck(this, BrowserUIReact);
    return _super.apply(this, arguments);
  }
  _createClass(BrowserUIReact, [{
    key: "render",
    value: function render(container, options) {
      log("render called directly on BrowserUIReact class: should not happen. Surface component should use internal render.");
      return null;
    }
  }]);
  return BrowserUIReact;
}(BrowserUIBase);

/**
 * Creates a new instance of the Toolkit for use with the React integration.
 * @param options
 */
function newInstance(options) {
  options = options || {};
  return new BrowserUIReact(options);
}

// export * from '@jsplumbtoolkit/browser-ui'

/**
 * Provides a React component wrapper around the Toolkit's DropManager.
 * @public
 */
var JsPlumbToolkitDragDropComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(JsPlumbToolkitDragDropComponent, _React$Component);
  var _super = _createSuper(JsPlumbToolkitDragDropComponent);
  function JsPlumbToolkitDragDropComponent(props) {
    var _this;
    _classCallCheck(this, JsPlumbToolkitDragDropComponent);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "surface", void 0);
    _defineProperty(_assertThisInitialized(_this), "toolkit", void 0);
    _defineProperty(_assertThisInitialized(_this), "container", void 0);
    _defineProperty(_assertThisInitialized(_this), "dropManager", void 0);
    if (!_this.props.surface) {
      throw new Error("No `surface` set on JsPlumbToolkitDragDropComponent. This is required.");
    }
    if (!_this.props.selector) {
      throw new Error("No 'selector' set on JsPlumbToolkitDragDropComponent. This is required.");
    }
    _this.surface = _this.props.surface;
    _this.toolkit = _this.surface.toolkitInstance;
    _this.container = _this.props.container;
    return _this;
  }
  _createClass(JsPlumbToolkitDragDropComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var params = {
        source: this.props.container,
        selector: this.props.selector,
        surface: this.surface,
        dataGenerator: function dataGenerator(el) {
          if (!_this2.props.dataGenerator) {
            return {
              type: "default"
            };
          } else {
            return _this2.props.dataGenerator(el);
          }
        }
      };
      if (this.props.onEdgeDrop) {
        params.onEdgeDrop = function (data, edge, el, evt, pageLocation) {
          var positionOnSurface = _this2.surface.fromPageLocation(pageLocation.x, pageLocation.y);
          _this2.props.onEdgeDrop(_this2.surface, data, edge, positionOnSurface, el, evt, pageLocation);
        };
      }
      if (this.props.onCanvasDrop) {
        params.onCanvasDrop = function (data, position) {
          _this2.props.onCanvasDrop(_this2.surface, data, position);
        };
      }
      if (this.props.onDrop) {
        params.onDrop = function (data, target, draggedElement, e, position) {
          _this2.props.onDrop(_this2.surface, data, target, position, draggedElement, e);
        };
      }
      this.dropManager = new DropManager(params);
    }
  }]);
  return JsPlumbToolkitDragDropComponent;
}(React.Component);

/**
 * Props for `SurfaceDropComponent`
 */

/**
 * Surface Drop Component - draggable nodes. This is an abstract component. You are expected to provide the `render` method.
 *
 * @param surface The surface component to attach to.
 * @param container The DOM element that contains the draggables.
 * @param selector CSS selector identifying elements to configure as draggables.
 * @param dataGenerator function to use to generate data for some dragged element.
 * @param typeGenerator Optional function to use to generate type for some element data; defaults to using the `type` member of the data.
 * @param groupIdentifier Optional function to use to distinguish between nodes/groups. Defaults to testing `jtk-is-group="true"` on the dragged element.
 * @param allowDropOnEdge Optional, defaults to true. When a node/group is dropped on an existing edge it is injected between the source and target of that edge and the original edge is removed.
 * @param allowDropOnCanvas Optional, defaults to true. When a node/group is dropped on the canvas, it is added to the dataset and rendered.
 * @param allowDropOnGroup Optional, defaults to true. When a node is dropped on a group it is rendered and added to the group.
 */
var SurfaceDropComponent = /*#__PURE__*/function (_React$Component2) {
  _inherits(SurfaceDropComponent, _React$Component2);
  var _super2 = _createSuper(SurfaceDropComponent);
  function SurfaceDropComponent(props) {
    var _this3;
    _classCallCheck(this, SurfaceDropComponent);
    _this3 = _super2.call(this, props);
    _defineProperty(_assertThisInitialized(_this3), "surface", void 0);
    _defineProperty(_assertThisInitialized(_this3), "toolkit", void 0);
    _defineProperty(_assertThisInitialized(_this3), "container", void 0);
    _defineProperty(_assertThisInitialized(_this3), "dropManager", void 0);
    if (!_this3.props.surface) {
      throw new Error("No `surface` set on SurfaceDropComponent. This is required.");
    }
    if (!_this3.props.selector) {
      throw new Error("No 'selector' set on SurfaceDropComponent. This is required.");
    }
    _this3.surface = _this3.props.surface;
    _this3.toolkit = _this3.surface.toolkitInstance;
    _this3.container = _this3.props.container;
    return _this3;
  }
  _createClass(SurfaceDropComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      var params = {
        source: this.props.container,
        selector: this.props.selector,
        surface: this.surface,
        dataGenerator: function dataGenerator(el) {
          if (!_this4.props.dataGenerator) {
            return {
              type: "default"
            };
          } else {
            return _this4.props.dataGenerator(el);
          }
        },
        allowDropOnEdge: this.props.allowDropOnEdge !== "false",
        allowDropOnGroup: this.props.allowDropOnGroup !== "false",
        allowDropOnCanvas: this.props.allowDropOnCanvas !== "false",
        typeGenerator: this.props.typeGenerator,
        groupIdentifier: this.props.groupIdentifier
      };
      this.dropManager = new SurfaceDropManager(params);
    }
  }]);
  return SurfaceDropComponent;
}(React.Component);

export { BaseGroupComponent, BaseNodeComponent, BasePortComponent, BaseVertexComponent, BrowserUIReact, JsPlumbToolkitDragDropComponent, JsPlumbToolkitMiniviewComponent, JsPlumbToolkitSurfaceComponent, SurfaceDropComponent, newInstance };
